import { MutationTree } from 'vuex';
import { cartInterFace } from '@/types/store';
import { instantLottoState } from '@/types/instant';

interface actionRemoveCart {
    cart: cartInterFace[];
    total: number;
}

export const mutations: MutationTree<instantLottoState> = {
    ADD_TO_CART(state, cart: cartInterFace[]) {
        state.totalInstant = cart?.length || 0;
        state.cartInstant = cart;
    },
    REMOVE_TO_CART(state, payload: actionRemoveCart) {
        state.totalInstant = payload.total;
        state.cartInstant = payload.cart;
    },
};

export default mutations;
